/**
 * Enum Loại hình đơn vị
 */
export default {
    None: 0,
    /**
     * Đơn vị hành chính được giao tự chủ kinh tế
     */
    BudgetIndependentPublicAgency: 1,
    /**
     * Đơn vị hành chính không được giao tự chủ kinh tế
     */
    NoneBudgetIndependentPublicAgency: 2,
    /**
     * Đơn vị SNCL tự đảm bảo một phần chi thường xuyên
     */
    SemiAutonomousSNCLPublicAgency: 3,
    /**
     * Đơn vị SNCL tự đảm bảo chi thường xuyên và chi đầu tư
     */
    SelfSNCLGoverningEntityWithFullFinancialAutonomy: 4,
    /**
     * Đơn vị SNCL đảm bảm chi thường xuyên
     */
    AutonomousSNCLPublicAgency: 5,
    /**
     * Đơn vị SNCL do Nhà nước đảm bảo chi thường xuyên
     */
    GovernmentFundedSNCLPublicEntity: 6,
    /**
     * Đơn vị khác
     */
    Other: 7,
};
